import styled from 'styled-components';

const ClientSiteFilterWrapper = styled.div`
  padding: 30px;
  min-height: ${(props) => (props?.removeWhiteSpace ? 'auto' : '175px')};

  .disable-site {
    opacity: 0.5;
    pointer-events: none;
  }

  .select-block {
    width: 200px;
  }

  .client-block {
    margin-right: 75px;
  }

  .select-label {
    color: gray;
  }
`;

export { ClientSiteFilterWrapper };
